import { createFileRoute } from '@tanstack/react-router'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@lead-magnifier/ui'
import { Building2, Users, Calendar, CreditCard } from 'lucide-react'

export const Route = createFileRoute('/_admin/dashboard')({
  component: AdminDashboard,
})

function AdminDashboard() {
  const stats = [
    {
      title: 'Mandanten',
      value: '0',
      description: 'Aktive Messeplätze',
      icon: Building2,
    },
    {
      title: 'Aussteller',
      value: '0',
      description: 'Registrierte Benutzer',
      icon: Users,
    },
    {
      title: 'Events',
      value: '0',
      description: 'Gesamt erstellt',
      icon: Calendar,
    },
    {
      title: 'Lizenzen',
      value: '0',
      description: 'Aktive Lizenzen',
      icon: CreditCard,
    },
  ]

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold">Platform Admin</h1>
        <p className="text-muted-foreground mt-2">
          Verwaltung aller Mandanten und System-Einstellungen.
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {stats.map((stat) => (
          <Card key={stat.title}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">{stat.title}</CardTitle>
              <stat.icon className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{stat.value}</div>
              <p className="text-xs text-muted-foreground">{stat.description}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle>Letzte Aktivitäten</CardTitle>
            <CardDescription>Systemweite Aktivitäten</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Keine Aktivitäten vorhanden.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Lizenz-Warnungen</CardTitle>
            <CardDescription>Mandanten mit niedrigen oder ablaufenden Lizenzen</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Keine Warnungen.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
